import type { ClassDefinition } from '../../shared/game/class-types.js';

// Oathsworn 3.0 draft, level 1: Radiant Judgment and Lay on Hands. Mana, Radiant spellcasting, Zealot, Sacred Decrees and the Oaths come later.
export const oathsworn: ClassDefinition = {
  id: 'oathsworn', name: 'Oathsworn',
  summary: 'A righteous defender of the weak and obliterator of evil: high Defense and high burst damage.',
  keyStats: ['strength', 'will'], hitDie: 10, startingHp: 17,
  saves: { advantage: ['strength'], disadvantage: ['dexterity'] },
  armor: ['cloth', 'leather', 'mail', 'plate', 'shield'], weapons: ['strength'],
  startingGear: ['Mace', 'Rusty Mail', 'Wooden Buckler', 'Manacles'], interposes: true,
  abilities: [
    {
      id: 'lay-on-hands', name: 'Lay on Hands', level: 1, actions: 1, target: 'ally', healTarget: true, autocast: true, healingPool: { perLevel: 5 },
      description: 'Touch a party member, yourself included, and spend healing power to restore the HP they are missing. The pool holds 5×LVL and refills on a Safe Rest. Ends Dying.',
    },
  ],
  passives: [{
    id: 'radiant-judgment', name: 'Radiant Judgment', level: 1, judgment: { count: 2, sides: 6 },
    description: 'When a foe attacks you and you hold none, roll 2d6 Judgment Dice. Your next melee attack this encounter adds them as radiant damage; a miss loses them.',
  }],
};
